// extracted by mini-css-extract-plugin
export default {"video-one-container":"VideoOne_video-one-container__cApGz","video-box":"VideoOne_video-box__Ez-Fy","no-video":"VideoOne_no-video__-kezO"};